var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 4"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 9 9)",
  fill: "#A3A3A3",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 9,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 16,
  r: 2
}))));

export default SvgIconMore;